import { mergeStyles, MotionAnimations, MotionDurations } from "@fluentui/react";

//#region CONTAINER

export const containerStyles = mergeStyles([{
    width: '100%',
    paddingTop: '5dvh',
    animation: MotionAnimations.fadeIn,
    animationDuration: MotionDurations.duration2,
}]);

export const xxlContainerStyles = mergeStyles([{
    width: '100%',
    paddingTop: 'clamp(3.5dvh, 4dvh, 4.5dvh)',
    animation: MotionAnimations.fadeIn,
    animationDuration: MotionDurations.duration2,
}]);

export const xlContainerStyles = mergeStyles([{
    width: '100%',
    paddingTop: 'clamp(3.5dvh, 3.75dvh, 4dvh)',
    animation: MotionAnimations.fadeIn,
    animationDuration: MotionDurations.duration2,
}]);

export const lgContainerStyles = mergeStyles([{
    width: '100%',
    paddingTop: 'clamp(3dvh, 3.5dvh, 4dvh)',
    animation: MotionAnimations.fadeIn,
    animationDuration: MotionDurations.duration2,
}]);

export const mdContainerStyles = mergeStyles([{
    width: '100%',
    paddingTop: 'clamp(2.5dvh, 3dvh, 3.5dvh)',
    animation: MotionAnimations.fadeIn,
    animationDuration: MotionDurations.duration2,
}]);

export const smContainerStyles = mergeStyles([{
    width: '100%',
    paddingTop: 'clamp(2dvh, 2.5dvh, 3dvh)',
    animation: MotionAnimations.fadeIn,
    animationDuration: MotionDurations.duration2,
}]);

//#endregion CONTAINER

//#region SUBCONTAINER

export const subContainerStyles = mergeStyles([{
    width: '100%',
    paddingTop: '4dvh'
}]);

export const xxlSubContainerStyles = mergeStyles([{
    width: '100%',
    paddingTop: 'clamp(2.5dvh, 3dvh, 3.5dvh)'
}]);

export const xlSubContainerStyles = mergeStyles([{
    width: '100%',
    paddingTop: 'clamp(2.5dvh, 3.5dvh, 3.75dvh)'
}]);

export const lgSubContainerStyles = mergeStyles([{
    width: '100%',
    paddingTop: 'clamp(2.25dvh, 3dvh, 3.5dvh)'
}]);

export const mdSubContainerStyles = mergeStyles([{
    width: '100%',
    paddingTop: 'clamp(2dvh, 2.5dvh, 3.25dvh)'
}]);

export const smSubContainerStyles = mergeStyles([{
    width: '100%',
    paddingTop: 'clamp(1.75dvh, 2dvh, 3dvh)'
}]);

//#endregion SUBCONTAINER

//#region FORM CONTAINER

export const formContainerStyles = mergeStyles([{
    width: '100%'
}]);

//#endregion FORM CONTAINER

//#region IMAGE CONTAINER

export const imageContainerStyles = mergeStyles([{
    width: '100%',
    marginBottom: 'clamp(1.8dvh, 2dvh, 2.2dvh)',
    gap: '0.5dvh'
}]);

export const xxlImageContainerStyles = mergeStyles([{
    width: '100%',
    marginBottom: 'clamp(1.6dvh, 1.8dvh, 2dvh)'
}]);

export const xlImageContainerStyles = mergeStyles([{
    width: '100%',
    marginBottom: 'clamp(1.4dvh, 1.7dvh, 1.9dvh)'
}]);

export const lgImageContainerStyles = mergeStyles([{
    width: '100%',
    marginBottom: 'clamp(1.4dvh, 1.6dvh, 1.8dvh)'
}]);

export const mdImageContainerStyles = mergeStyles([{
    width: '100%',
    marginBottom: 'clamp(1.2dvh, 1.4dvh, 1.6dvh)'
}]);

export const smImageContainerStyles = mergeStyles([{
    width: '100%',
    marginBottom: 'clamp(1dvh, 1.2dvh, 1.4dvh)'
}]);

//#endregion IMAGE CONTAINER

//#region TITLE CONTAINER

export const titleContainerStyles = mergeStyles([{
    width: '100%',
    marginBottom: '2dvh',
    gap: '0.5dvh'
}]);

export const xxlTitleContainerStyles = mergeStyles([{
    width: '100%',
    marginBottom: 'clamp(1.8dvh, 2dvh, 2.2dvh)',
    gap: 'clamp(0.4dvh, 0.5dvh, 0.6dvh)'
}]);

export const xlTitleContainerStyles = mergeStyles([{
    width: '100%',
    marginBottom: 'clamp(1.6dvh, 1.8dvh, 2dvh)',
    gap: 'clamp(0.35dvh, 0.45dvh, 0.55dvh)'
}]);

export const lgTitleContainerStyles = mergeStyles([{
    width: '100%',
    marginBottom: 'clamp(1.4dvh, 1.6dvh, 1.8dvh)',
    gap: 'clamp(0.3dvh, 0.4dvh, 0.5dvh)'
}]);

export const mdTitleContainerStyles = mergeStyles([{
    width: '100%',
    marginBottom: 'clamp(1.2dvh, 1.4dvh, 1.6dvh)',
    gap: 'clamp(0.25dvh, 0.35dvh, 0.45dvh)'
}]);

export const smTitleContainerStyles = mergeStyles([{
    width: '100%',
    marginBottom: 'clamp(1dvh, 1.2dvh, 1.4dvh)',
    gap: 'clamp(0.2dvh, 0.3dvh, 0.4dvh)'
}]);

//#endregion TITLE CONTAINER

//#region TITLE

export const titleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: '2rem',
    fontWeight: 600,
    color: '#2A7DE1',

    textAlign: 'left'
}]);

export const xxlTitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(1.4rem, 2.5vw, 1.5rem)',
    fontWeight: 600,
    color: '#2A7DE1',

    textAlign: 'left'
}]);

export const xlTitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(1.3rem, 2.5vw, 1.4rem)',
    fontWeight: 600,
    color: '#2A7DE1',

    textAlign: 'left'
}]);

export const lgTitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(1.2rem, 2.5vw, 1.3rem)',
    fontWeight: 600,
    color: '#2A7DE1',

    textAlign: 'left'
}]);

export const mdTitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(1.1rem, 2.5vw, 1.2rem)',
    fontWeight: 600,
    color: '#2A7DE1',

    textAlign: 'left'
}]);

export const smTitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(1rem, 2.5vw, 1.1rem)',
    fontWeight: 600,
    color: '#2A7DE1',

    textAlign: 'left'
}]);

//#endregion TITLE

//#region SUBTITLE

export const subTitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: '1rem',
    fontWeight: 300,
    color: '#323130',

    textAlign: 'left'
}]);

export const xxlSubTitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(0.8rem, 2.3vw, 1rem)',
    fontWeight: 300,
    color: '#323130',

    textAlign: 'left'
}]);

export const xlSubTitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(0.7rem, 2.2vw, 0.9rem)',
    fontWeight: 300,
    color: '#323130',

    textAlign: 'left'
}]);

export const lgSubTitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(0.8rem, 2vw, 1.1rem)',
    fontWeight: 300,
    color: '#323130',

    textAlign: 'left'
}]);

export const mdSubTitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(0.7rem, 1.9vw, 1rem)',
    fontWeight: 300,
    color: '#323130',

    textAlign: 'left'
}]);

export const smSubTitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(0.8rem, 2vw, 1rem)',
    fontWeight: 300,
    color: '#323130',

    textAlign: 'left'
}]);

//#endregion SUBTITLE

//#region INNERTITLE

export const innerTitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: '2rem',
    fontWeight: 400,
    color: '#2A7DE1',

    textAlign: 'left'
}]);

export const xxlInnerTitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(0.9rem, 2.5vw, 1rem)',
    fontWeight: 400,
    color: '#2A7DE1',
    textAlign: 'left'
}]);

export const xlInnerTitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(0.85rem, 2.5vw, 0.95rem)',
    fontWeight: 400,
    color: '#2A7DE1',
    textAlign: 'left'
}]);

export const lgInnerTitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(0.8rem, 2.5vw, 0.9rem)',
    fontWeight: 400,
    color: '#2A7DE1',
    textAlign: 'left'
}]);

export const mdInnerTitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(0.75rem, 2.5vw, 0.85rem)',
    fontWeight: 400,
    color: '#2A7DE1',
    textAlign: 'left'
}]);

export const smInnerTitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(0.7rem, 2.5vw, 0.8rem)',
    fontWeight: 400,
    color: '#2A7DE1',
    textAlign: 'left'
}]);

//#endregion INNERTITLE

//#region INNERSUBTITLE

export const subInnerTitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: '1rem',
    fontWeight: 300,
    color: '#323130',

    textAlign: 'left'
}]);

export const xxlSubInnerTitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(0.85rem, 2.5vw, 0.95rem)',
    fontWeight: 300,
    color: '#323130',
    textAlign: 'left'
}]);

export const xlSubInnerTitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(0.8rem, 2.5vw, 0.9rem)',
    fontWeight: 300,
    color: '#323130',
    textAlign: 'left'
}]);

export const lgSubInnerTitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(0.75rem, 2.5vw, 0.85rem)',
    fontWeight: 300,
    color: '#323130',
    textAlign: 'left'
}]);

export const mdSubInnerTitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(0.7rem, 2.5vw, 0.8rem)',
    fontWeight: 300,
    color: '#323130',
    textAlign: 'left'
}]);

export const smSubInnerTitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(0.65rem, 2.5vw, 0.75rem)',
    fontWeight: 300,
    color: '#323130',
    textAlign: 'left'
}]);

//#endregion INNERSUBTITLE
